import { render, staticRenderFns } from "./CoverageItemKindList.vue?vue&type=template&id=69f37afa"
import script from "./CoverageItemKindList.vue?vue&type=script&lang=js"
export * from "./CoverageItemKindList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports